import { Box, Grid, FormControl, IconButton, MenuItem, Select, Stack, Switch, TextField, Typography, InputLabel, Divider } from '@mui/material';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _ from 'lodash';
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import momenttz from "moment-timezone";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import StarlinkAddIcon from "../../asset/image/StarlinkAddIcon.svg"
import DeleteIcon from "../../asset/image/delete2.svg";

const QuotaActions = ({ entries, handleValueChange, handleRemoveEntry, revertEntries, handleRevertValueChange, handleAddEntry, handleRemoveRevertEntry, handleAddRevertEntry }) => {
    return (
        <Stack className="sub-tab-parent" direction="column" spacing={1}>
            <Grid container className="config-apply-config-target" >
                <Grid xs={12} sm={12} md={12} lg={12} className="configuration-form-build">
                    
                       
                        <Box className="starlink-section-heading">
                            <Typography className="starlink-section-title">Quota</Typography>
                            <Divider className='starlink-section-divider' />
                        </Box>
                        <Grid  ml={2} className='starlinkPlans-quota-scroll'>
                            {entries?.length === 0 && (
                                        <IconButton
                                            onClick={handleAddEntry}
                                            color="primary">
                                            <img src={StarlinkAddIcon} style={{ width: "24px", height: "24px", cursor: "pointer" }} />
                                        </IconButton>
                                    )}
                        {entries && entries?.map((entry, index) => (
                            <Grid item xs={12} key={index} justifyContent="flex-start" className="strPlans-quotaActions" >

                                <Grid item xs={2}>
                                    <FormControl fullWidth>
                                        <TextField
                                            size="small"
                                            variant="outlined"
                                            value={entry?.usagePercentage}
                                            type="number"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*\.?\d*$/.test(value) && (value === "" || parseFloat(value) > 0)) {
                                                    handleValueChange(index, 'usagePercentage', value);
                                                }
                                            }}
                                            inputProps={{
                                                inputMode: 'numeric',
                                                pattern: '[0-9]*',
                                                min: "0",
                                                step: "any"
                                            }}
                                            sx={{
                                                "& .MuiInputBase-root": {
                                                    height: "37px",
                                                },
                                                "& .MuiInputBase-input": {
                                                    height: "37px",
                                                    padding: "5px 10px",
                                                },
                                            }}
                                        />

                                    </FormControl>
                                </Grid>
                                <Grid item xs={2}> <Typography> % Used </Typography></Grid>
                                <Grid item xs={5} className="strPlan-marginGrid">
                                    <FormControl fullWidth size="small" className="strPlans-marginTop">
                                        <Select
                                            fullWidth
                                            size="small"
                                            value={entry.type}
                                            onChange={(e) => handleValueChange(index, 'type', e.target.value)}
                                        >
                                            <MenuItem value="sendNotification">Send Notification</MenuItem>
                                            <MenuItem value="pauseServiceLine">Pause Service Line</MenuItem>
                                            <MenuItem value="optOut">Mobile Priority (Opt Out)</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={2} display="flex" alignItems="center">
                                    { (
                                        <IconButton
                                            onClick={() => handleRemoveEntry(index)}
                                            color="secondary"
                                        >
                                                 <img src={DeleteIcon} style={{ width: "24px", height: "24px", cursor: "pointer" }} />
                                        </IconButton>
                                    )}
                                    {index === entries?.length - 1 && (
                                        <IconButton
                                            onClick={handleAddEntry}
                                            color="primary">
                                            <img src={StarlinkAddIcon} style={{ width: "24px", height: "24px", cursor: "pointer" }} />
                                        </IconButton>
                                    )}
                                </Grid>
                            </Grid>
                        ))  }
                    </Grid>

                    <Grid xs={12} sm={12} md={12} lg={12} ml={2}>
                        <Box className="starlink-section-heading">
                            <Typography className="starlink-section-title">Revert</Typography>
                            <Divider className='starlink-section-divider' />
                        </Box>
                        <Grid item xs={12} container spacing={2} >
                            <Grid item xs={12} display="flex" alignItems="center" justifyContent="flex-start">
                                <Grid item xs={6} display="flex" flexDirection="column">
                                    {revertEntries && revertEntries.map((entry, index) => (
                                        <Grid
                                            container
                                            key={index}
                                            spacing={2}
                                            sx={{mb:1}}
                                            className="revert-entry-grid"
                                        >
                                            <Grid item xs={9} className="strPlan-marginGrid">
                                                <FormControl fullWidth size="small" className="strPlans-marginTop">
                                                    <Select

                                                        fullWidth
                                                        size="small"
                                                        value={entry.type}
                                                        onChange={(e) => handleRevertValueChange(index, 'type', e.target.value)}
                                                    >
                                                        <MenuItem value="resumeServiceLine">Resume All Service Lines </MenuItem>
                                                        <MenuItem value="optIn">Opt In All Service Lines </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={1} display="flex" alignItems="center">
                                                <IconButton
                                                    onClick={() => handleRemoveRevertEntry(index)}
                                                    color="secondary"
                                                >
                                                  <img src={DeleteIcon} style={{ width: "24px", height: "24px", cursor: "pointer" }} />
                                                </IconButton>

                                                {revertEntries?.length < 2 && (
                                                    <IconButton onClick={handleAddRevertEntry} color="primary">
                                                        <img src={StarlinkAddIcon} style={{ width: "24px", height: "24px", cursor: "pointer" }} />
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        </Grid>
                                    ))}
                                    {revertEntries?.length === 0 && (
                                        <Grid item style={{ paddingLeft: '10px' }}>
                                            <IconButton onClick={handleAddRevertEntry} color="primary">
                                                <img src={StarlinkAddIcon} style={{ width: "24px", height: "24px", cursor: "pointer" }} />
                                            </IconButton>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        </Grid>
                    </Grid>
                </Grid>
          
        </Stack>

    );
};

const mapStateToProps = (state) => ({
});

export default withRouter(
    connect(mapStateToProps, {})(QuotaActions)
)